<script setup lang="ts">
import { Training } from "@/types/training/Training";
import CautionContainer from "@/components/molecules/CautionContainer.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";

const props = defineProps({
  training: {
    type: Object as () => Training,
    required: true
  }
});

const emit = defineEmits({
  start: () => true
});

function onClickStart() {
  emit("start");
}
</script>

<template>
  <div class="cover">
    <div class="header">
      <h3>{{ training.title }}</h3>
      <div class="question-count">{{ training.questions.length }}問</div>
    </div>
    <div class="content">
      <div class="description">
        <div class="description-title">CHECK</div>
        <div class="description-content">
          <p>業務開始前に研修を受講してください</p>
        </div>
        <div class="description-image">
          <img
            src="@/assets/img/caikuma_running.png"
            alt="カイクマ"
            class="caikuma"
          />
        </div>
      </div>
      <CautionContainer>
        <template #title>すでに打刻済みです</template>
        <template #content>
          <p>研修受講時間も勤務時間に含まれます</p>
        </template>
      </CautionContainer>
    </div>
    <div class="bottom">
      <AppButton @click="onClickStart" class="next-button"
        >研修を受講する</AppButton
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cover {
  display: flex;
  flex-direction: column;
  height: 100dvh;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: calc(env(safe-area-inset-top) + 24px) 24px 24px 24px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
}

.question-count {
  font-size: 16px;
  color: #31373f;
}

h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
}

.content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 40px;
  align-items: center;
  justify-content: flex-start;
  overflow: auto;
}

.description {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  padding: 24px 24px 0;

  .description-title {
    font-size: 48px;
    font-weight: 700;
    line-height: 48px;
    color: #70c8d5;
  }

  .description-content {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #31373f;
  }
}

.caikuma {
  width: 113px;
  height: auto;
}

.bottom {
  display: flex;
  justify-content: center;
  padding: 24px 24px calc(env(safe-area-inset-bottom) + 24px) 24px;
  border-top: 1px solid #e5e5e5;

  .next-button {
    width: 100%;
    font-size: 16px;
  }
}
</style>
